// Game constants ported from Java Constants.java

export const GAME_CONSTANTS = {
  // Game metadata
  GAME_NAME: 'Avoin Areena',
  GAME_VERSION: 'v0.2',

  // Difficulty levels
  GAME_DIFFICULTY: ['Helppo', 'Normaali', 'Vaikea', 'Mahdoton'] as const,

  // Finnish month names
  MONTHS: [
    'Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu',
    'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu',
    'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'
  ] as const,

  // Team and money
  MONEY_PREFIX: 'Rahat',
  MONEY_SUFFIX: 'kr',
  START_MONEY_DIV_1: 10000,
  START_MONEY_DIV_2: 5000,
  START_MONEY_DIV_3: 2000,
  START_MONEY_DIV_4: 1500,
  START_RATING: 70,
  START_ARENA_POINTS: 100,

  // Division structure
  DIVISIONS: 4,
  TEAMS_IN_DIVISION: 4,

  // Recruitment
  RECRUIT_TURNS: 3,
  RECRUIT_GLADIATOR_COUNT: 8,

  // Shop pricing
  DISCOUNT_PRICE: 0.9,
  SELL_PRICE: 0.75,

  // Combat
  CRITICAL_HIT_CHANCE_PERCENTAGE: 10,
  CRITICAL_HIT_DMG_MULTIPLIER: 2.0,
  SKILL_MAX_VALUE: 90,

  // Gladiator limits
  GLADIATOR_MIN_AGE: 20,
  GLADIATOR_MAX_AGE: 35,
  MAX_GLADIATORS_IN_TEAM: 9,
  MAX_GLADIATORS_IN_BATTLE: 6,
  MAX_START_GLADIATORS: 4,
  MAX_SPELLS: 4,
  AMMO_COUNT: 20,

  // Equipment slots
  MELEE_WEAPON_SLOT: 0,
  RANGED_WEAPON_SLOT: 1,
  ARMOUR_SLOT: 2,

  // Battle
  MAX_BATTLE_ROUNDS: 40,
  MAP_WIDTH: 7,
  MAP_HEIGHT: 10,
  MAP_TILE_SIZE: 34,
  DRAW_BATTLE_GRID: false,

  // Hit markers
  HITMARK_HIT: 0,
  HITMARK_MISS: 1,
  HITMARK_KO: 2,
  HITMARK_SPELL_1: 3,
  HITMARK_SPELL_2: 4,

  // Shoot modes
  SHOOT_MODE_RANGED_WEAPON: 1,
  SHOOT_MODE_SPELL: 2,

  // Year
  START_YEAR: 900,
  YEAR_SUFFIX: 'AD',

  // Season rewards
  KILL_LEADER_BONUS: 500, // Money bonus for owning the top killer of the season
} as const;

// Month types for the calendar
export const MONTH_TYPE = {
  DIVISION_BATTLE: 0,
  CUP_BATTLE: 1,
  WINTER_BREAK: 2,
} as const;

// Monthly schedule: which type of activity happens each month
export const MONTH_SCHEDULE = [
  MONTH_TYPE.DIVISION_BATTLE, // Tammikuu (0)
  MONTH_TYPE.DIVISION_BATTLE, // Helmikuu (1)
  MONTH_TYPE.CUP_BATTLE,      // Maaliskuu (2)
  MONTH_TYPE.DIVISION_BATTLE, // Huhtikuu (3)
  MONTH_TYPE.CUP_BATTLE,      // Toukokuu (4)
  MONTH_TYPE.DIVISION_BATTLE, // Kesäkuu (5)
  MONTH_TYPE.CUP_BATTLE,      // Heinäkuu (6)
  MONTH_TYPE.DIVISION_BATTLE, // Elokuu (7)
  MONTH_TYPE.CUP_BATTLE,      // Syyskuu (8)
  MONTH_TYPE.DIVISION_BATTLE, // Lokakuu (9)
  MONTH_TYPE.WINTER_BREAK,    // Marraskuu (10)
  MONTH_TYPE.WINTER_BREAK,    // Joulukuu (11)
] as const;

// Type exports for convenience
export type MonthType = typeof MONTH_TYPE[keyof typeof MONTH_TYPE];
export type Difficulty = typeof GAME_CONSTANTS.GAME_DIFFICULTY[number];
export type Month = typeof GAME_CONSTANTS.MONTHS[number];
